module.exports = __webpack_public_path__ + "static/allviewports-6d65410f08317de591d9f2b23b809c90.mp4";